module.exports = __webpack_public_path__ + "img/item_Portrait_06.c2e918d1.jpeg";